import React from "react";

function Active() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1387_2465)">
        <path
          d="M4.87286 9.33744L7.24576 12.0572L13.1206 5.95264"
          stroke="#3CAF47"
          strokeWidth="1.19028"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.99574 17.3399C13.5996 17.3399 17.3318 13.6077 17.3318 9.0038C17.3318 4.39991 13.5996 0.667725 8.99574 0.667725C4.39186 0.667725 0.659668 4.39991 0.659668 9.0038C0.659668 13.6077 4.39186 17.3399 8.99574 17.3399Z"
          stroke="#3CAF47"
          strokeWidth="1.19028"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1387_2465">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Active;
